<template>
  <div>
    <!-- ===================== LIST ===================== -->
    <div v-if="view === 'list'">
      <div class="card mar-to-15" style="width: calc(100% - 20px); margin-left: 10px; margin-right: 10px;">
        <div class="card-content">
          <div class="text-right">
            <p>
              <button class="btn add" @click.prevent="openForm(null)">
                <img src="/static/img/icons/add.png">
                {{ $t('deliveryPreferences.zoneAdd') }}
              </button>
            </p>
          </div>

          <div v-loading="loading">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th style="width:70px">ID</th>
                  <th>{{ $t('deliveryPreferences.name') }}</th>
                  <th v-if="taxesVersion !== 2">{{ $t('deliveryPreferences.shippingCost') }}</th>
                  <th v-else>Taxe de livrare</th>
                  <th>{{ $t('deliveryPreferences.type') }}</th>
                  <th style="width:110px">{{ $t('zoneAvailability.activeColumn') }}</th>
                  <th style="width:200px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="zone in zones" :key="zone.id">
                  <td>{{ zone.id }}</td>
                  <td>{{ zone.name }}</td>
                  <td v-if="taxesVersion !== 2">{{ zone.shipping_cost }}</td>
                  <td v-else>
                    <span v-for="tax in zoneDeliveryTaxes(zone.id)" :key="tax.id" class="zone-tax-badge">{{ tax.name }}</span>
                    <span v-if="!zoneDeliveryTaxes(zone.id).length" class="text-muted">Nicio taxă</span>
                  </td>
                  <td>
                    <span v-if="zone.editable" class="badge" style="background:#4caf50; color:#fff; padding:3px 8px; border-radius:4px;">
                      {{ $t('deliveryPreferences.companyZone') }}
                    </span>
                    <span v-else class="badge" style="background:#9e9e9e; color:#fff; padding:3px 8px; border-radius:4px;">
                      {{ $t('deliveryPreferences.locationZone') }}
                    </span>
                    <span v-if="zone.schedule_enabled" class="badge" style="background:#2196f3; color:#fff; padding:3px 8px; border-radius:4px;">
                      {{ $t('zoneAvailability.withSchedule') }}
                    </span>
                  </td>
                  <td>
                    <p-switch
                      v-if="zone.editable"
                      :name="'zoneActive_' + zone.id"
                      :value="zone.active !== false"
                      @input="val => toggleActive(zone, val)"
                      type="success"></p-switch>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td>
                    <button v-if="zone.editable" class="btn btn-sm btn-info" style="margin-right:6px;" @click.prevent="openForm(zone.id)">
                      <i class="fa fa-pencil"></i> {{ $t('general.edit') }}
                    </button>
                    <button class="btn btn-sm btn-icon btn-info" :title="$t('deliveryPreferences.clone')" @click.prevent="cloneZone(zone)">
                      <i class="ti-files"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="!loading && !zones.length">
                  <td colspan="6" class="text-center">{{ $t('deliveryPreferences.noData') }}</td>
                </tr>
              </tbody>
            </table>
            <p><small class="text-muted">{{ $t('deliveryPreferences.legacyReadonly') }}</small></p>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================== FORM (company zones only, real map editor) ===================== -->
    <div v-else>
      <div class="settings-top-bar">
        <div class="top-bar">
          <p>
            <a class="btn btn-orange btn-icon back" @click.prevent="backToList">
              <i class="ti-arrow-left"></i> {{ $t('deliveryPreferences.back') }}
            </a>
          </p>
          <p class="d-inline-flex">
            <a v-if="model.id" class="btn btn-danger btn-icon delete mar-rt-10" style="padding: 7px 10px; margin-right: 20px;" @click.prevent="remove">
              <img src="/static/img/icons/icon-close.png"> {{ $t('general.delete') }}
            </a>
            <button class="btn btn-icon btn-success save mar-rt-10" @click.prevent="save">
              <img src="/static/img/icons/save.png"> {{ $t('general.save') }}
            </button>
          </p>
        </div>
      </div>

      <div class="row mar-to-15" v-loading="loading">
        <div class="col-lg-12 col-md-12">
          <p class="text-danger" v-if="formError" style="margin: 0 15px;">{{ formError }}</p>
          <div class="form-group" v-if="overlayOptions.length" style="margin: 0 15px 15px;">
            <label>{{ $t('deliveryPreferences.showOtherZones') }}</label>
            <el-select
              v-model="overlayZoneIds"
              multiple
              filterable
              collapse-tags
              style="width: 100%; display: block;"
              :placeholder="$t('deliveryPreferences.showOtherZonesPlaceholder')">
              <el-option
                v-for="z in overlayOptions"
                :key="z.id"
                :label="z.name || ('#' + z.id)"
                :value="z.id">
              </el-option>
            </el-select>
          </div>
          <delivery-google-maps
            v-if="mapReady"
            :key="mapKey"
            :googleMapsapiKey="mapContext.google_maps_api_key"
            :cityFromParent="mapContext.city"
            :locationMarker="{ lat: mapContext.lat, lng: mapContext.lng, name: mapContext.name }"
            :showTheRestOfTheZones="overlayZones.length > 0"
            :zoneInComp="model"
            :nameInvalid="attemptedSave && !model.name"
            :deliveryRanges="mapZones"
            :indexZone="0"
            :bussLocationId="mapContext.token"
            :location_id="null"
            :hideDeleteZone="true"
            :orderType="'delivery'"
            :currency="currency"
            :vatOptions="vatOptions"
            :taxes-version="taxesVersion"
            @update-zone="handleUpdateZone"
          ></delivery-google-maps>
          <zone-availability-editor
            v-if="mapReady"
            :zone="model"
            :showErrors="attemptedSave"
          ></zone-availability-editor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
import DeliveryGoogleMaps from 'src/components/Dashboard/Views/Maps/DeliveryGoogleMaps.vue'
import ZoneAvailabilityEditor from './ZoneAvailabilityEditor.vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import { zoneAvailabilityError, zoneAvailabilityPayload } from './zoneAvailability'

export default {
  components: {
    DeliveryGoogleMaps,
    ZoneAvailabilityEditor,
    PSwitch
  },
  data () {
    return {
      view: 'list',
      loading: true,
      mapReady: false,
      attemptedSave: false,
      formError: '',
      zones: [],
      overlayZoneIds: [],
      model: this.emptyModel(),
      vatOptions: [],
      deliveryTaxRules: [],
      taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
      currency: '',
      mapContext: { google_maps_api_key: '', city: '', lat: null, lng: null, name: '', token: null }
    }
  },
  computed: {
    // Company zones (with a drawn shape) that can be shown on the map as reference,
    // excluding the one currently being edited.
    overlayOptions () {
      return this.zones.filter(z => z.id !== this.model.id && z.shape && z.shape.type)
    },
    // The selected reference zones, resolved from their ids.
    overlayZones () {
      return this.overlayOptions.filter(z => this.overlayZoneIds.indexOf(z.id) !== -1)
    },
    // What we hand to the map: the edited zone first, then the reference overlays.
    mapZones () {
      return [this.model].concat(this.overlayZones)
    },
    // Changing this key remounts the map so DeliveryGoogleMaps recomputes the
    // overlay zones (it only reads deliveryRanges once, in created()).
    mapKey () {
      return 'zmap-' + (this.model.id || 'new') + '-' + this.overlayZoneIds.slice().sort().join('_')
    }
  },
  created () {
    this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso'])
    this.loadMapContext()
    this.getData()
    this.loadDeliveryTaxes()
  },
  methods: {
    sessionData (extra = {}) {
      return Object.assign({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, extra)
    },
    emptyModel () {
      return {
        id: null,
        name: '',
        shipping_cost: 0,
        shipping_cost_vat_id: null,
        shipping_pos_id: '',
        min_order_value: 0,
        extra_delivery_time: 0,
        shape: {},
        override_payment_method: false,
        accept_cash: false,
        accept_card: false,
        accept_pos: false,
        delivery_range_cost_rules: []
      }
    },
    getData () {
      this.loading = true
      this.apiRequest('/delivery-zone', 'GET', this.sessionData(), (response) => {
        if (response.status === true) {
          this.zones = response.data
        }
        this.loading = false
      })
    },
    loadDeliveryTaxes () {
      if (this.taxesVersion !== 2) return
      this.apiRequest('/taxes-v2/rules', 'GET', this.sessionData(), (response) => {
        this.deliveryTaxRules = response.status ? (response.data || []) : []
      })
    },
    zoneDeliveryTaxes (zoneId) {
      return this.deliveryTaxRules.filter(rule => {
        if (!rule || rule.applies_to !== 'delivery') return false
        const ranges = rule.delivery_range_ids || []
        return !ranges.length || ranges.some(id => String(id) === String(zoneId))
      })
    },
    // A company-level zone is not tied to a location, but the map editor still needs a
    // Google Maps key (to show the "Extra Cost Range" section) and a location token (to
    // resolve VAT options). We borrow both from a company location — preferring one that
    // has a maps key AND some VAT rows so the map tools and the VAT dropdown both work.
    // Locations (with google_maps_api_key + token) are already in the session from login.
    loadMapContext () {
      const companyData = this.$session.get('selectedCompanyData') || {}
      const locations = companyData.locations_details || []
      this.apiRequest('/location/vat', 'GET', this.sessionData({ location_ids: null }), (response) => {
        if (response.status === true) {
          this.vatOptions = response.data || []
        }
        const tokensWithVat = {}
        this.vatOptions.forEach(v => { tokensWithVat[v.location_token] = true })
        const chosen = locations.find(l => l.google_maps_api_key && tokensWithVat[l.token]) ||
                       locations.find(l => l.google_maps_api_key) ||
                       locations[0]
        if (chosen) {
          this.mapContext = {
            google_maps_api_key: chosen.google_maps_api_key || '',
            city: chosen.city || '',
            lat: null,
            lng: null,
            name: chosen.name || '',
            token: chosen.token
          }
        }
      })
    },
    openForm (id) {
      this.formError = ''
      this.attemptedSave = false
      this.mapReady = false
      this.overlayZoneIds = []
      if (id) {
        const zone = this.zones.find(z => z.id === id)
        // deep clone so cancelling does not mutate the list row
        const clone = JSON.parse(JSON.stringify(zone))
        if (!clone.shape || Array.isArray(clone.shape)) clone.shape = clone.shape && clone.shape.length ? clone.shape : {}
        if (!clone.delivery_range_cost_rules) clone.delivery_range_cost_rules = []
        this.model = clone
      } else {
        this.model = this.emptyModel()
      }
      this.view = 'form'
      // let the map mount after the model/context are set
      this.$nextTick(() => { this.mapReady = true })
    },
    backToList () {
      this.mapReady = false
      this.view = 'list'
      this.getData()
      this.loadDeliveryTaxes()
    },
    // Quick active/inactive switch from the list (company zones only).
    toggleActive (zone, active) {
      const previous = zone.active !== false
      this.$set(zone, 'active', active)
      this.apiRequest('/delivery-zone/' + zone.id + '/active', 'POST', this.sessionData({ active: active }), (response) => {
        if (response.success === true) {
          swal({ text: this.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1200 }).then(() => {}).catch(() => {})
        } else {
          this.$set(zone, 'active', previous)
          swal({ text: this.firstError(response.errors) || this.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(() => {}).catch(() => {})
        }
      })
    },
    handleUpdateZone (zone) {
      this.model = zone
    },
    cloneZone (zone) {
      const self = this
      swal({
        title: self.$t('deliveryPreferences.cloneName'),
        input: 'text',
        inputValue: (zone.name || '') + ' (copy)',
        showCancelButton: true,
        confirmButtonText: self.$t('deliveryPreferences.clone')
      }).then((result) => {
        const name = result && result.value !== undefined ? result.value : result
        if (name === false || name === undefined || name === null) return
        self.loading = true
        self.apiRequest('/delivery-zone/' + zone.id + '/clone', 'POST', self.sessionData({ name: name }), (response) => {
          self.loading = false
          if (response.success === true) {
            swal({ text: self.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(() => {}).catch(() => {})
            self.getData()
          } else {
            swal({ text: self.firstError(response.errors) || self.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(() => {}).catch(() => {})
          }
        })
      }).catch(() => {})
    },
    save () {
      this.attemptedSave = true
      const hasShape = !!(this.model.shape && this.model.shape.type)
      if (!this.model.name || !hasShape) {
        if (!this.model.name && !hasShape) {
          this.formError = this.$t('general.fillRequiredFields') + ' ' + this.$t('deliveryPreferences.drawShapeRequired')
        } else if (!this.model.name) {
          this.formError = this.$t('general.fillRequiredFields')
        } else {
          this.formError = this.$t('deliveryPreferences.drawShapeRequired')
        }
        return
      }
      const availabilityError = zoneAvailabilityError(this.model, this.$t.bind(this))
      if (availabilityError) {
        this.formError = availabilityError
        return
      }
      this.formError = ''
      this.loading = true

      const costRules = (this.model.delivery_range_cost_rules || [])
        .filter(r => !r.deleted)
        .map(r => ({
          id: r.id,
          min_order_value: r.min_order_value,
          shipping_cost: r.shipping_cost,
          shipping_pos_id: r.shipping_pos_id,
          distance_in_km: r.distance_in_km,
          extra_delivery_time: r.extra_delivery_time
        }))

      const payload = this.sessionData(Object.assign({
        name: this.model.name,
        shipping_cost: this.model.shipping_cost,
        shipping_cost_vat_id: this.model.shipping_cost_vat_id,
        shipping_pos_id: this.model.shipping_pos_id,
        min_order_value: this.model.min_order_value,
        extra_delivery_time: this.model.extra_delivery_time,
        shape: this.model.shape,
        override_payment_method: this.model.override_payment_method,
        accept_cash: this.model.accept_cash,
        accept_card: this.model.accept_card,
        accept_pos: this.model.accept_pos,
        cost_rules: costRules
      }, zoneAvailabilityPayload(this.model)))

      const url = this.model.id ? '/delivery-zone/' + this.model.id : '/delivery-zone'
      const method = this.model.id ? 'PUT' : 'POST'

      this.apiRequest(url, method, payload, (response) => {
        this.loading = false
        if (response.success === true) {
          swal({ text: this.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(() => {}).catch(() => {})
          this.backToList()
        } else {
          this.formError = this.firstError(response.errors)
        }
      })
    },
    remove () {
      const self = this
      swal({
        title: self.$t('deliveryPreferences.deleteConfirm'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then((result) => {
        if (result && (result.value || result === true)) {
          self.loading = true
          self.apiRequest('/delivery-zone/' + self.model.id, 'PUT', self.sessionData({ delete: true }), (response) => {
            self.loading = false
            if (response.success === true) {
              swal({ text: self.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(() => {}).catch(() => {})
              self.backToList()
            } else {
              swal({ text: self.firstError(response.errors) || self.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(() => {}).catch(() => {})
            }
          })
        }
      }).catch(() => {})
    },
    firstError (errors) {
      if (!errors) return ''
      const keys = Object.keys(errors)
      if (!keys.length) return ''
      const v = errors[keys[0]]
      return Array.isArray(v) ? v[0] : v
    }
  }
}
</script>

<style scoped>
.zone-tax-badge {
  background: #e5faf5;
  border: 1px solid #bceee3;
  border-radius: 14px;
  color: #079778;
  display: inline-block;
  font-size: 12px;
  margin: 2px 5px 2px 0;
  padding: 4px 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/DeliveryPreferences/SettingsDeliveryZones.vue